import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "userDeliveryAddress-skeleton",
  ref: "skeletonRef"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "line-one"
}, "_", -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "line-two"
}, "_", -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "line-three"
}, "_", -1);
const _hoisted_5 = [_hoisted_2, _hoisted_3, _hoisted_4];
const _hoisted_6 = {
  class: "userDeliveryAddress",
  ref: "shortAddressRef"
};
const _hoisted_7 = ["disabled"];
const _hoisted_8 = {
  class: "formattedAddress hide",
  ref: "formattedAddressRef"
};
const _hoisted_9 = {
  class: "delivery-truck-modal__header"
};
const _hoisted_10 = {
  class: "delivery-truck-modal__title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TruckIcon = _resolveComponent("TruckIcon");
  const _component_AlertIcon = _resolveComponent("AlertIcon");
  const _component_CloseIcon = _resolveComponent("CloseIcon");
  const _component_DeliveryTruckLoggedIn = _resolveComponent("DeliveryTruckLoggedIn");
  const _component_DeliveryTruckLoggedOut = _resolveComponent("DeliveryTruckLoggedOut");
  return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(), _createBlock(_Teleport, {
    to: $options.teleportID
  }, [_createElementVNode("div", {
    class: "header-truck-container",
    onKeydown: _cache[5] || (_cache[5] = _withKeys((...args) => $options.closeModal && $options.closeModal(...args), ["esc"]))
  }, [_createElementVNode("a", {
    class: "cmp--header_truck-modal",
    tabindex: "0",
    onMouseover: _cache[0] || (_cache[0] = (...args) => $options.toggleAddressInfo && $options.toggleAddressInfo(...args)),
    onMouseleave: _cache[1] || (_cache[1] = (...args) => $options.toggleAddressInfo && $options.toggleAddressInfo(...args)),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.openModal && $options.openModal(...args)),
    onKeyup: _cache[3] || (_cache[3] = _withKeys((...args) => $options.openModal && $options.openModal(...args), ["enter"]))
  }, [_createVNode(_component_TruckIcon, {
    class: "truck-icon"
  }), _createElementVNode("div", _hoisted_1, _hoisted_5, 512), _withDirectives(_createElementVNode("p", {
    class: "userDeliveryAddress",
    ref: "shortAddressRef"
  }, _toDisplayString($data.currentUserCountry), 513), [[_vShow, !_ctx.isAuthenticated || !this.$store.state.user.dccUserInfo?.data?.canShowTruck]]), _withDirectives(_createElementVNode("p", _hoisted_6, null, 512), [[_vShow, _ctx.isAuthenticated && this.$store.state.user.dccUserInfo?.data?.canShowTruck]])], 32), _createElementVNode("button", {
    class: "info-icon-container hide",
    ref: "infoIconRef",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.toggleAddressInfo && $options.toggleAddressInfo(...args)),
    disabled: $data.isModalOpen
  }, [_createVNode(_component_AlertIcon, {
    class: "info-icon"
  }), _createElementVNode("span", _hoisted_8, null, 512)], 8, _hoisted_7)], 32)], 8, ["to"])), (_openBlock(), _createBlock(_Teleport, {
    to: $options.teleportModalID
  }, [$data.isModalOpen ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "delivery-truck-modal",
    onKeydown: _cache[6] || (_cache[6] = _withKeys((...args) => $options.closeModal && $options.closeModal(...args), ["esc"]))
  }, [_createElementVNode("div", {
    class: _normalizeClass(["delivery-truck-modal__content", {
      'loggedIn': this.$store.state.user.isAuthenticated && this.$store.state.user.dccUserInfo?.data?.canShowTruck
    }])
  }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("h4", _hoisted_10, [_createVNode(_component_TruckIcon), _createElementVNode("b", null, _toDisplayString($data.headerTitle), 1)]), !$data.hideCloseIcon ? (_openBlock(), _createBlock(_component_CloseIcon, {
    key: 0,
    class: "closeDeliveryTruckModal",
    onClick: $options.closeModal
  }, null, 8, ["onClick"])) : _createCommentVNode("", true)]), $options.showLoggedInTruck ? (_openBlock(), _createBlock(_component_DeliveryTruckLoggedIn, {
    key: 0,
    onCloseModal: $options.closeModal,
    ref: "deliveryTruckLoggedIn"
  }, null, 8, ["onCloseModal"])) : (_openBlock(), _createBlock(_component_DeliveryTruckLoggedOut, {
    key: 1,
    onCloseModal: $options.closeModal
  }, null, 8, ["onCloseModal"]))], 2)], 32)) : _createCommentVNode("", true)], 8, ["to"]))], 64);
}